import {StorageUtility} from './Storage';
import {URLManager} from './URLManager';

declare var window: any;
declare var $: any;

export class Marketing {
    private static instance: Marketing;

    static getInstance(): Marketing {
        if (!Marketing.instance) {
            Marketing.instance = new Marketing();
        }
        return Marketing.instance;
    }

    public send_sms(extension, phone, recaptcha, callback) {
        const payload = {
            extension,
            phone,
            recaptcha,
            ...URLManager.getInstance().getDefaultParams(),
            // consider also sending this to HubSpot..... Why not?
        };

        const ajax = $.ajax({
            url: window.keeperPreload.apiEndpoint + '/bi_api/rest/forms/sms',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(payload),
            dataType: 'json',
        });

        ajax.done(response => {
            callback(response);
        });

        ajax.fail(response => {
            callback(response);
        });
    }

    public send_chat_sms(extension, phone, recaptcha, isChatSMS, callback) {
        const payload = {
            extension,
            phone,
            recaptcha,
            isChatSMS,
            ...URLManager.getInstance().getDefaultParams(),
        };

        const ajax = $.ajax({
            url: window.keeperPreload.apiEndpoint + '/bi_api/rest/forms/sms',
            type: 'POST',
            data: JSON.stringify(payload),
            contentType: 'application/json',
            dataType: 'json',
        });

        ajax.done(response => {
            callback(response);
        });

        ajax.fail(response => {
            callback(response);
        });
    }

    public getBlogPostsFormatted(postsCount, callback) {
        $.ajax({
            url: 'https://www.keepersecurity.com/blog',
            type: 'get',
            dataType: 'html',
            success(data) {
                const $data = $(data);
                const theBlogPosts = [];
                const allBlogPosts = $data.find('.postsGrid .thePost');
                allBlogPosts.each((index, item) => {
                    if (index > 2) return;
                    const theTitle = $(item).find('h3 a').text();
                    const thePostURL = $(item).find('h3 a').attr('href');
                    const theSummary = $(item).find('.summary p').text();
                    theBlogPosts.push({title: theTitle, summary: theSummary, url: thePostURL});
                });

                let blogRollString = '';
                for (let i = 0; i < postsCount; i++) {
                    blogRollString += '<div class="blogPost">';
                    blogRollString +=
                        '<p class="postTitle"><a href="' +
                        theBlogPosts[i].url +
                        '">' +
                        theBlogPosts[i].title +
                        '</a></p>';
                    blogRollString += '<p class="postSummary">' + theBlogPosts[i].summary + '</p>';
                    blogRollString +=
                        '<p class="postButton"><a class="btn-clear-yellow" href="' +
                        theBlogPosts[i].url +
                        '">Read More</a></p>';
                    blogRollString += '</div>';
                }
                callback(blogRollString);
            },
        });
    }

    public getBlogPosts(callback) {
        $.ajax({
            url: 'https://www.keepersecurity.com/blog',
            type: 'get',
            dataType: 'html',
            success: data => {
                data = data.replace(/<img[^>]*>/g, '');
                const $data = $(data);
                const posts = [];
                const domPosts = $data.find('.postsGrid .thePost');
                domPosts.each((index, item) => {
                    const image = $(item)
                        .find('.tpImage a picture source:last-child')
                        .attr('srcset');
                    const title = $(item).find('h3 a').text();
                    const url = $(item).find('h3 a').attr('href');
                    const summary = $(item).find('.summary p').text();
                    const excerpt = $(item).find('.summary p').html().substring(0, 120);
                    posts.push({
                        image,
                        title,
                        summary,
                        excerpt,
                        url,
                    });
                });
                callback(posts);
            },
        });
    }

    public getAppRatings(callback) {
        $.ajax({
            url: window.keeperPreload.apiEndpoint + '/bi_api/v1/webapi/app_ratings',
            type: 'get',
            dataType: 'json',
            timeout: 3000,
            success: response => {
                callback(response || {});
            },
            error: response => {
                try {
                    if (
                        response &&
                        response.responseText &&
                        response.responseText.trim().startsWith('{')
                    ) {
                        callback(JSON.parse(response.responseText));
                    } else {
                        console.error('App ratings API returned non-JSON:', response);
                        callback({});
                    }
                } catch (e) {
                    console.error('Error parsing app ratings response:', e, response);
                    callback({});
                }
            },
        });
    }

    public appendToLeadURL(key, value) {
        if (key === 'pageKey') {
            this.prependToLeadURL(key, value);
            return;
        }

        let leadParams = StorageUtility.getInstance().getLocal('lead_source_params');
        if (leadParams && leadParams.indexOf('?') !== -1) {
            leadParams = leadParams + '&' + key + '=' + value;
        } else {
            leadParams = '?' + key + '=' + value;
        }
        StorageUtility.getInstance().setLocal('lead_source_params', leadParams);
    }

    public prependToLeadURL(key, value) {
        let leadParams = StorageUtility.getInstance().getLocal('lead_source_params');

        if (leadParams && leadParams.indexOf('?') !== -1) {
            leadParams = leadParams.replace('?', '?' + key + '=' + value + '&');
        } else {
            leadParams = '?' + key + '=' + value;
        }

        StorageUtility.getInstance().setLocal('lead_source_params', leadParams);
    }

    /**
     * @summary Clears leads
     * @since 12.0.0
     */
    public clearLeads = () => {
        StorageUtility.getInstance().removeLocal('lead_source');
        StorageUtility.getInstance().removeLocal('lead_source_params');
        StorageUtility.getInstance().removeLocal('secondary_lead_source');
    };

    /**
     * @summary Append key/value pair to lead_source_params cookie.
     * @since 12.0.0
     * @param {string} key - The key to append.
     * @param {string} value - The value to append.
     */
    public appendLead = (key, value) => {
        if (key === 'pageKey') {
            this.prependLead(key, value);
            return;
        }

        let params = StorageUtility.getInstance().getLocal('lead_source_params');

        if (params && params.indexOf('?') != -1) params = params + '&' + key + '=' + value;
        else params = '?' + key + '=' + value;

        StorageUtility.getInstance().setLocal('lead_source_params', params);
    };

    /**
     * @summary Prepend key/value pair to lead_source_params cookie.
     * @since 12.0.0
     * @param {string} key - The key to append.
     * @param {string} value - The value to append.
     */
    public prependLead = (key, value) => {
        let params = StorageUtility.getInstance().getLocal('lead_source_params');

        if (params && params.indexOf('?') !== -1) {
            params = params.replace('?', '?' + key + '=' + value + '&');
        } else {
            params = '?' + key + '=' + value;
        }

        StorageUtility.getInstance().setLocal('lead_source_params', params);
    };

    /**
     * @summary Calls the material design component handler to refresh material design elements.
     * @since 16.0.0
     */

    public getHubspotParams(portal, form) {
        const request: any = {};

        request.hubspot = {
            portalID: portal,
            formID: form,
        };

        request.hubspot.context = {};
        request.hubspot.context.hutk = '';
        request.hubspot.context.pageUri = window.location.href || '';
        request.hubspot.context.pageName = document.querySelector('title').text || '';

        if (StorageUtility.getInstance().isAvailable()) {
            request.hubspot.context.hutk = StorageUtility.getInstance().getCookie('hubspotutk');
        }

        return request;
    }

    public b2bLeadConversionEvent(formName, hashedEmail) {
        try {
            var leadPayload = {hashedEmail, formName};
            var evt = new CustomEvent('b2b_lead_converted', {detail: leadPayload});
            window.dispatchEvent(evt);
        } catch (error) {}
    }

    public b2cLeadConversionEvent(formName) {
        try {
            var leadPayload = {formName};
            var evt = new CustomEvent('b2c_lead_converted', {detail: leadPayload});
            window.dispatchEvent(evt);
        } catch (error) {}
    }
}

export default Marketing;
